// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb832e21","455":"2a045b06","977":"76bff82d"}[chunkId] + ".chunk.js";
};